import {
  ProductTemplate,
  ProductTemplateAsSalzburgProps,
} from "@made-people/blueprint-product";
import {
  ProductList,
  ProductListProps,
} from "@made-people/blueprint-product-list";
import { withManagedProps } from "@made-people/managed-props";

/**
 * In this file you can specify default props for components that render,
 * which have been wrapped with withManagedProps
 */

export const ProductsDefaults = {
  loadMore: {
    indicators: ["seenProducts"],
    buttonVariants: {
      style: "solid",
      width: "full",
    },
  },
  layout: {
    spacing: {
      x: {
        initial: "none",
        md: "none",
        lg: "lg",
      },
    },
  },
  variants: {
    columns: { initial: "1", lg: "1" },
  },
  fallback: {
    amountOfItems: 1,
  },
  skeletonCard: {
    variants: {
      size: { initial: "portrait", lg: "wide" },
    },
  },
  header: {
    isEnabled: false,
  },
} satisfies ProductListProps;

export const Products = withManagedProps(
  "Products",
  (
    props: ProductListProps & {
      heading?: string;
      description?: string;
      productVariants?: ProductTemplateAsSalzburgProps["variants"];
    },
  ) => {
    return (
      <ProductList
        {...props}
        loadMore={{
          enabled: false,
        }}
        component={
          <ProductTemplate
            template="salzburg"
            variants={props.productVariants}
            nameSettings={{
              text:
                props?.heading && props?.heading?.length > 0
                  ? props?.heading
                  : undefined,
            }}
            descriptionSettings={{
              text:
                props?.description && props?.description?.length > 0
                  ? props?.description
                  : undefined,
            }}
          />
        }
      />
    );
  },
);
